module.exports = {"130324100":"卢龙镇","130324101":"潘庄镇","130324102":"燕河营镇","130324103":"双望镇","130324104":"刘田各庄镇","130324105":"石门镇","130324106":"木井镇","130324107":"陈官屯镇","130324108":"蛤泊镇","130324200":"下寨乡","130324201":"刘家营乡","130324203":"印庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130324.json
// module id = 191
// module chunks = 0